import { Typography,  Box, Stack, Button } from "@mui/material";
import hero1 from "../assets/images/hero_images/hero_1.webp";
import hero_offer from "../assets/images/hero_images/hero_offer.webp";
import hero2 from "../assets/images/hero_images/hero_2.webp";
import hero4 from "../assets/images/hero_images/hero_4.webp";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
export default function HeroSection() {
  const navigate = useNavigate();
  const heroImages = [hero1, hero_offer,hero2,hero4];
  const [currentImage, setCurrentImage] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % heroImages.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [heroImages.length]);
  return (
    <Box
      sx={{
        position: "relative",
        height: "800px",
        width: "100%",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          overflow: "hidden",
        }}
      >
        {heroImages.map((img, index) => (
          <Box
            key={index}
            sx={{
              position: "absolute",
              inset: 0,
              backgroundImage: `
          linear-gradient(
            to right,
            rgba(255,255,255,1) 0%,
            rgba(240,238,238,0.59) 30%,
            rgba(0,0,0,0) 50%
          ),
          linear-gradient(
            to top,
            rgba(255,255,255,1) 0%,
            rgba(100,99,99,0.33) 15%,
            rgba(0,0,0,0) 35%
          ),
          url(${img})
        `,
              backgroundSize: "cover",
              backgroundPosition: "center",
              opacity: index === currentImage ? 1 : 0,
              transition: "opacity 1.2s ease-in-out",
              transform: "scale(1.05)",
            }}
          />
        ))}
      </Box>

      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          display: "flex",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Stack sx={{ ml: 2 }}>
          <Typography
            variant="h1"
            sx={{
              fontSize: {
                xs: "3.5rem",
                sm: "4.6rem",
                md: "5.5rem",
              },
              opacity: 0,
              animation: "heroText 0.5s ease-out forwards",
              animationDelay: "0.1s",
              "@keyframes heroText": {
                from: {
                  opacity: 0,
                  transform: "translateY(40px)",
                },
                to: {
                  opacity: 1,
                  transform: "translateY(0)",
                },
              },
            }}
            color="#252525ff"
          >
            Baked Fresh,
          </Typography>
          <Typography
            variant="h1"
            sx={{
              fontSize: {
                xs: "3.5rem",
                sm: "4.6rem",
                md: "5.5rem",
              },
              opacity: 0,
              transform: "translateY(30px)",
              animation: "fadeUp 0.5s ease-out forwards",
              "@keyframes fadeUp": {
                from: {
                  opacity: 0,
                  transform: "translateY(30px)",
                },
                to: {
                  opacity: 1,
                  transform: "translateY(0)",
                },
              },
            }}
            color="rgb(255, 157, 0)"
          >
            Made with
          </Typography>
          <Typography
            variant="h1"
            sx={{
              fontSize: {
                xs: "3.5rem",
                sm: "4.6rem",
                md: "5.5rem",
              },
              opacity: 0,
              transform: "translateY(30px)",
              animation: "fadeUp 0.5s ease-out forwards",
              "@keyframes fadeUp": {
                from: {
                  opacity: 0,
                  transform: "translateY(30px)",
                },
                to: {
                  opacity: 1,
                  transform: "translateY(0)",
                },
              },
            }}
            color="rgb(212, 131, 0)"
          >
            Passion
          </Typography>
          <Box
            sx={{
              height: "5px",
              maxWidth: "316px",
              borderRadius: "20px",
              background: "linear-gradient(45deg, #f5b041ff, #ffffff44)",
              opacity: 0,
              transform: "translateY(30px)",
              animation: "fadeUp 0.6s ease-out forwards",
              "@keyframes fadeUp": {
                from: {
                  opacity: 0,
                  transform: "translateY(30px)",
                },
                to: {
                  opacity: 1,
                  transform: "translateY(0)",
                },
              },
            }}
          />
          <Typography
            sx={{
              mt: 2,
              maxWidth: "700px",
              wordWrap: "break-word",
              fontSize: "20px",
              color: "#1d1c1cff",
              opacity: 0,
              transform: "translateY(30px)",
              animation: "fadeUp 0.7s ease-out forwards",
              "@keyframes fadeUp": {
                from: {
                  opacity: 0,
                  transform: "translateY(30px)",
                },
                to: {
                  opacity: 1,
                  transform: "translateY(0)",
                },
              },
            }}
          >
            Discover our artisan cakes, pastries, and treats made from the
            finest ingredients. Every bite tells a story of craftsmanship and
            love
          </Typography>
          <Box
            sx={{
              mt: 3,
              opacity: 0,
              transform: "translateY(30px)",
              animation: "fadeUp 0.9s ease-out forwards",
              "@keyframes fadeUp": {
                from: {
                  opacity: 0,
                  transform: "translateY(30px)",
                },
                to: {
                  opacity: 1,
                  transform: "translateY(0)",
                },
              },
            }}
          >
            <Button
              onClick={() => navigate("/menu")}
              sx={{
                background: "linear-gradient(45deg, #f29c24, #d56d12)",
                borderRadius: "12px",
                px: 2.2,
                py: 1.1,
                color: "white",
                fontWeight: "bold",
                textTransform: "none",
                display: "flex",
                alignItems: "center",
                gap: 1,

                transition: "transform 0.25s ease, box-shadow 0.25s ease",

                "& .arrow": {
                  transition: "transform 0.25s ease",
                },

                "&:hover": {
                  transform: "scale(1.02)",
                  boxShadow: "0 2px 15px rgba(0,0,0,0.25)",
                },

                "&:hover .arrow": {
                  transform: "translateX(6px)", // 👉 arrow moves right
                },
              }}
            >
              View Our Menu
              <ArrowForwardIosIcon
                className="arrow"
                sx={{ fontSize: "16px" }}
              />
            </Button>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "row", mt: 5 }}>
            <Stack direction={"column"}>
              <Typography
                variant="h4"
                sx={{
                  fontSize: "2.2rem",
                  color: "#d4860aff",
                  display: "inline-block",
                  transition: "transform 0.3s ease, color 0.25s ease",
                  cursor: "pointer",
                  "&:hover": {
                    transform: "scale(1.08)",
                    color: "#cf9237",
                  },
                }}
              >
                50+
              </Typography>
              <Typography sx={{ fontSize: "14px", color: "#484848ff" }}>
                Cake Varieties
              </Typography>
            </Stack>
            <Stack direction={"column"} sx={{ ml: 10 }}>
              <Typography
                variant="h4"
                sx={{
                  fontSize: "2.2rem",
                  color: "#d4860aff",
                  display: "inline-block",
                  transition: "transform 0.3s ease, color 0.25s ease",
                  cursor: "pointer",
                  "&:hover": {
                    transform: "scale(1.08)",
                    color: "#cf9237",
                  },
                }}
              >
                10k+
              </Typography>
              <Typography sx={{ fontSize: "14px", color: "#484848ff" }}>
                Happy Customers
              </Typography>
            </Stack>
          </Box>
        </Stack>
      </Box>
      <Box
        sx={{
          position: "absolute",
          bottom: 30,
          left: "50%",
          transform: "translateX(-50%)",
          display: "flex",
          gap: 1.5,
        }}
      >
        {heroImages.map((_, index) => (
          <Box
            key={index}
            sx={{
              width: index === currentImage ? 28 : 10,
              height: 10,
              borderRadius: "20px",
              backgroundColor: index === currentImage ? "#f29c24" : "#e3d6c5",
              transition: "all 0.4s ease",
            }}
          />
        ))}
      </Box>
    </Box>
  );
}
